<template>
  <section>
    <div class="lm-local__message-foreign">
      <div class="lm-local-message-header">
        <p class="lm-local-message-header__source">
          {{ anotherMessage.messageSource }}
        </p>
        <p>
          <span class="lm-local-message-header__user">
            {{ anotherMessage.userCode }} - {{ anotherMessage.userName }}
          </span>
          <span class="lm-local-message-header__date">
            {{ anotherMessage.createdAt }}
          </span>
        </p>
      </div>
      <div class="lm-local-message-contents">
        {{ anotherMessage.message }}
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MessageForeign',
  computed: {
    anotherMessage () {
      return this.$attrs
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/messages/MessageForeign.vue